import styled from 'styled-components/macro';
import SimpleButton from 'styled/Buttons/SimpleButton';

const Delete = styled(SimpleButton)`
  padding: 3px;
  opacity: 0.6;
  cursor: pointer;
  transition: opacity 0.15s ease-out;

  &:hover {
    opacity: 1;
  }

  svg {
    width: 9px;
    height: 9px;
  }
`;

export default Delete;
